import React from 'react';
const Tags = ({ tags = [], offersCount, handleTagClick, showMultipleTag, newTagsStyle, Component, defaultColor = false, }) => {
    if (!Array.isArray(tags)) {
        return null;
    }
    let sortedTags = tags;
    if (!showMultipleTag) {
        sortedTags = tags.sort();
    }
    if (!(sortedTags === null || sortedTags === void 0 ? void 0 : sortedTags.length) || !Component)
        return null;
    return (React.createElement(React.Fragment, null, sortedTags.map((tag, index) => (React.createElement(Component, { index: index, customStyle: newTagsStyle === null || newTagsStyle === void 0 ? void 0 : newTagsStyle[index], showMultipleTag: showMultipleTag, tag: tag, handleTagClick: handleTagClick, offersCount: offersCount, defaultColor: defaultColor })))));
};
export default Tags;
